module.exports = __webpack_public_path__ + "static/media/destaque-admin.894ff4b6.png";